import { useState } from "react";
import useApiImageUploader from "../Api/Settings/changePhotoApi";
import showToast from "./toast";

const useImageUploader = () => {
  const sendApi = useApiImageUploader();
  const [sendImage, setSendImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file && file.size > 8 * 1024 * 1024) {
        setSendImage(null);
        showToast('The maximum file size is 8 MB', "error");
      } else {
        setSendImage(file);
        setPreviewImage(URL.createObjectURL(file));
        sendApi.send(file);
      }

    }
  };

  return {
    sendImage,
    previewImage,
    handleFileChange,
    setPreviewImage,
  };
};

export default useImageUploader;
